import React, { useRef, useState } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useSelector, useDispatch } from 'react-redux';
import { SYSTEM_ID_SENIORITIES, MIND_PATTERNS_DATA_REPORTS, MIND_PATTERNS_DATA_AREAS } from '../../../core/constants';
import { CommunityFilters } from '../../components/community/CommunityFilters';
import { CommunityResults } from '../../components/community/CommunityResults';
import { systemActions } from '../../../core/system';
import { useEffect } from 'react';
import { questionsListActions } from '../../../core/questions-list';
import { getMindPatternsDataById, mindPatternsDataActions } from '../../../core/mind-patterns';
import { communityActions } from '../../../core/community-search/actions';

const animationClass = {
    appearActive: 'animate__animated animate__slideInRight',
    enter: 'animate__animated',
    enterActive: 'animate__animated animate__slideInRight',
    exit: 'animate__animated',
    exitActive: 'animate__animated animate__slideOutLeft position-absolute top-0 left-0',
}

export const Community = () => {
    const dispatch = useDispatch()
    const nodeRef = useRef(null);
    const user = useSelector(state => state.user)
    const { data } = useSelector(state => state.community)
    const questions = useSelector(state => state.questions)
    const reports = useSelector(state => getMindPatternsDataById(state, MIND_PATTERNS_DATA_REPORTS))
    const mindPatternsAreas = useSelector(state => getMindPatternsDataById(state, MIND_PATTERNS_DATA_AREAS));
    const [filters, setFilters] = useState([])
    const [search, setSearch] = useState('')
    const [componentKey, setComponentKey] = useState(0);

    const refreshComponent = () => {
        setComponentKey(prevKey => prevKey + 1);
    };

    useEffect(() => {
        dispatch(systemActions.loadSystem(SYSTEM_ID_SENIORITIES))
        if(!reports) dispatch(mindPatternsDataActions.loadMindPatternsData(MIND_PATTERNS_DATA_REPORTS))
        if(questions && !questions.isPending && !questions.id) dispatch(questionsListActions.loadQuestions())
    }, [dispatch, questions, reports])

    useEffect(() => {
        if(!mindPatternsAreas?.items && !mindPatternsAreas?.isPending) {
            dispatch(mindPatternsDataActions.loadMindPatternsData(MIND_PATTERNS_DATA_AREAS))
        }
    },[dispatch, mindPatternsAreas])

    const getMemberByFilters = () => {
        let formatFilters = {};
        formatFilters['name'] = search;

        filters.forEach(filter => {
            const filterData = filter.type === 'mind_patterns' ? { mp: filter.mp } : { id: filter.id };
            if (!formatFilters[filter.type]) {
                formatFilters[filter.type] = [];
            }

            formatFilters[filter.type].push(filterData);
        });

        dispatch(communityActions.searchMemberByFilters(formatFilters, 1))
    }

    useEffect(() => {
        refreshComponent();
    }, [data])

    useEffect(() => {
        getMemberByFilters();
    }, [filters])

    return (
        <>
            {!user.isPending &&
                <div className="container-fluid minh-100">
                    <div className="view overflow-hidden smember-content">
                        <TransitionGroup component={null}>
                            <CSSTransition nodeRef={nodeRef} classNames={animationClass} timeout={{ enter: 1000, exit: 1000 }} appear >
                                <div ref={nodeRef} className="w-100">
                                    <div className='mb-3 pt-md-4'>
                                        <h1 className='mb-2 libre-caslon-text-regular h3-md h4'>Search Members</h1>
                                    </div>
                                    <CommunityFilters key={componentKey} filters={filters} setFilters={setFilters} search={search} setSearch={setSearch} refreshComponent={refreshComponent} />
                                    <CommunityResults filters={filters} setFilters={setFilters} />
                                </div>
                            </CSSTransition>
                        </TransitionGroup>
                    </div>
                </div>
            }
        </>
    )
}